export default [
    {
        path: '/sfc',
        component: ()=> import('@/layouts/FullWidthLayout.vue'),
        children: [
            {
                path: '',
                component: () => import('@/views/login/Procedure.vue')
            }
        ]
    },
    // /login y /signup comparten SignAppLayout + SignAppShell: al navegar entre
    // ellas Vue reutiliza ambas instancias y solo cambia el contenido de la tarjeta.
    {
        path: '/login',
        component: ()=> import('@/layouts/SignAppLayout.vue'),
        children: [
            {
                path: '',
                component: () => import('@/views/login/SignAppShell.vue'),
                children: [
                    {
                        path: '',
                        component: () => import('@/views/login/Login.vue')
                    }
                ]
            }
        ]
    },
    {
        path: '/signup',
        component: ()=> import('@/layouts/SignAppLayout.vue'),
        children: [
            {
                path: '',
                component: () => import('@/views/login/SignAppShell.vue'),
                children: [
                    {
                        path: '',
                        component: () => import('@/views/login/Signup.vue')
                    }
                ]
            }
        ]
    },
    {
        path: '/logout',
        component: ()=> import('@/layouts/FullWidthLayout.vue'),
        children: [
            {
                path: '',
                component: () => import('@/views/login/Logout.vue')
            }
        ]
    },
    {
        path: '/verify',
        component: ()=> import('@/layouts/FullWidthLayout.vue'),
        children: [
            {
                path: '',
                name: 'Verify',
                props: true,
                component: () => import('@/views/login/Verify.vue'),
            }
        ]
    },
    {
        path: '/recovery',
        component: ()=> import('@/layouts/FullWidthLayout.vue'),
        children: [
            {
                path: '',
                component: () => import('@/views/login/Recovery.vue'),
                meta: {
                    breadcrumb: [
                        {label: 'Inicio', link: '/'},
                        {label: 'Restablecer contraseña'}
                    ]
                },
            },
            {
                path: 'restore',
                component: () => import('@/views/login/Recovery.vue'),
                meta: {
                    breadcrumb: [
                        {label: 'Inicio', link: '/'},
                        {label: 'Restablecer contraseña'}
                    ]
                }
            }
        ]
    },    {
        path: '/technical-support',
        component: ()=> import('@/layouts/FullWidthLayout.vue'),
        children: [
            {
                path: '',
                name: 'TechnicalSupport',
                props: true,
                component: () => import('@/views/login/RegisterTechnicalSupport.vue'),
            }
        ]
    },
]